import type {
  ChakraTheme,
  SystemStyleObject,
  ThemeComponentProps,
} from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"
import { fontVariants } from "theme/fontVariants"

type InputProps = ThemeComponentProps<ChakraTheme> & {
  isError?: boolean
}

export const Input = {
  baseStyle: ({ isError }: InputProps): SystemStyleObject => ({
    field: {
      backgroundColor: colours.secondary.light,
      borderWidth: "1px",
      borderColor: isError
        ? `${colours.error.light}`
        : `${colours.primary.medium}`,
    },
  }),
  variants: {
    bp: {
      field: {
        borderRadius: 0,
        padding: "-1",
        color: colours.primary.medium,
        fontSize: "0.9375rem",
        "&::placeholder": {
          ...fontVariants.book1,
          fontSize: "0.9375rem",
        },
      },
    },
    squareButton: {
      ...fontVariants.light1,
      textIndent: "1000em",
      background: colours.accent.soft,
    },

    form: {
      field: {
        ...fontVariants.book0,
        borderRadius: "0.25rem",
        color: colours.primary.dark,
        padding: "1rem",
        height: "3rem",
      },
    },
  },
}
